// extracted by mini-css-extract-plugin
export default {"mds-alert":"mds-alert"};